import axios from 'axios'

const OtherTask = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('audit/other-events', { params })
  },

  async reports (params = {}) {
    return axios.get('audit/reports/other-events', { params })
  },

  async exports (params = {}) {
    return axios.get('audit/exports/other-events', { params })
  },

  async show (id) {
    return axios.get(`audit/other-events/${id}`)
  },

  async post (params = {}) {
    return axios.post('audit/other-events', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`audit/other-events/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`audit/other-events/${data.id}`, { data })
  }
}

export default OtherTask
